<template>
<div class="chapter">
<div class="inner_page">
<p class="chap1">Contents</p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/int">Introduction</a></p>
<p class="toc1"><a href="#/part01">I. L<span class="small">ADY</span> K<span class="small">ILLERS</span></a></p>
<p class="toc"><a href="#/chapter01">1. Paula Angel: Hanged Twice for Love</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Dora Dwenger: Black Widow of the Territory</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Bronco Sue: New Mexico’s First Serial Man Killer?</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Valentina Madrid and Alma Lyons: Partners in a Crime of Passion</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Ada Hulmes: Territorial Nightingale</span></p>
<p class="toc1"><span href="#/part02" title="Link target outside of Sample">II. G<span class="small">AMBLING</span> Q<span class="small">UEENS</span></span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Lottie Deno: Queen of the Pasteboards</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Belle Siddons: Lady Gambler and Spy</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Doña Tules: Queen of Sin</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Belle La Marr: Madam Varnish</span></p>
<p class="toc1"><span href="#/part03" title="Link target outside of Sample">III. S<span class="small">OILED</span> D<span class="small">OVES</span></span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Lizzie McGrath: The Lilly of Copper Avenue and the Shady Ladies of Albuquerque</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Madam Millie and the Tarnished Women of Silver City</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Beulah M’Rose and the Spirited Ladies of Phenix</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Sadie Orchard: Lady with a Heart of Gold</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Loma Parda Denizens: Military Disrupters</span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?516cdfec